import { styleBetaBlock } from './StyleBetaBLock'

const BetaBlock = ({ sectionRef }) => {
    return (
        <BetaBlockSC id="howToGet">
            <CustomContainerSC>
                <BetaTitleSC ref={sectionRef}>
                    Успейте записаться на бета-тест!
                </BetaTitleSC>
                <BetaListSC>
                    <BetaListItemSC>
                        <BetaListIconSC />
                        <BetaListItemTextSC>
                            Персональные цены и привилегии после релиза
                        </BetaListItemTextSC>
                    </BetaListItemSC>
                    <BetaListItemSC>
                        <BetaListIconSC />
                        <BetaListItemTextSC>
                            Обратная связь и влияние на разработку продукта
                        </BetaListItemTextSC>
                    </BetaListItemSC>
                    <BetaListItemSC>
                        <BetaListIconSC />
                        <BetaListItemTextSC>
                            Внедрение новых технологий раньше конкурентов
                        </BetaListItemTextSC>
                    </BetaListItemSC>
                </BetaListSC>
                <BetaButtonSC href="#form">
                    Записаться на бета-тест
                </BetaButtonSC>
            </CustomContainerSC>
        </BetaBlockSC>
    )
}

const {
    BetaListSC,
    BetaTitleSC,
    BetaBlockSC,
    BetaButtonSC,
    BetaListItemSC,
    BetaListIconSC,
    CustomContainerSC,
    BetaListItemTextSC,
} = styleBetaBlock()

export default BetaBlock
